import { Box, Text, BreakpointsContext, TColor } from '@centra/centra-ui'
import React, { FC, useContext } from 'react'

import styles from './TaskCompany.module.scss'
import { ArchivedIcon } from '../taskManager/Task/_ArchivedIcon/ArchivedIcon'
import { ITaskClient } from '../../store/taskManager/model'
import { TTextSize, TTextWeight } from '@centra/centra-ui/dist/atoms/Text/models'

export const TaskCompany: FC<{
  client?: ITaskClient
  clientHref?: string
  fontSize?: TTextSize
  fontWight?: TTextWeight
  fontColor?: TColor
}> = ({ client, clientHref, fontSize = 'caption', fontWight = 'regular', fontColor = 'basicGreySemiDark' }) => {
  if (!client) return null

  //Если есть агентство, то отображаем время архивирования агентства, иначе - клиента
  const archivedTime = client?.agencyArchivedAt || client?.archivedAt
  const archivedClientKind =
    !client?.agencyArchivedAt && client?.kind === 'agencyClient' ? 'Клиент агентства' : 'Клиент'

  return (
    <Box gap={4} alignItems={'center'} wrap>
      <Box gap={4} alignItems={'center'} wrap>
        {client.agencyName && (
          <Box gap={4} alignItems={'center'}>
            {client?.agencyArchivedAt && <ArchivedIcon archivedAt={archivedTime!} clientKind={archivedClientKind} />}
            <Text
              id="taskAgencyName"
              color={client?.agencyArchivedAt ? 'basicGreySemiDark' : fontColor}
              size={fontSize}
              noOfLines={1}
              className={styles.textOffline}
              weight={fontWight}
            >
              {`${client.agencyName} /`}
            </Text>
          </Box>
        )}
        <Box alignItems={'center'} gap={4}>
          {!client?.agencyArchivedAt && client?.archivedAt && (
            <ArchivedIcon archivedAt={archivedTime!} clientKind={archivedClientKind} />
          )}
          <Text
            id="taskClientName"
            color={client?.archivedAt || client?.agencyArchivedAt ? 'basicGreySemiDark' : fontColor}
            size={fontSize}
            noOfLines={1}
            className={styles.textOffline}
            href={clientHref}
            weight={fontWight}
          >
            {client.name}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
